import axios from 'axios';
import { Notification, MessageBox } from 'element-ui';
import { errorMsgMap } from '~/util/errorCodeMap';
// import store from '../store/index';
// const region = store.state.index.selectRegion;
// const userInfo = JSON.parse(store.state.index.userInfo || '{}');
const Axios = axios.create({
  // baseURL: '/api', //需要本地做反向代理
  baseURL: '/', //需要本地做反向代理
  timeout: 60000, //设置超时时间
  responseType: 'json',
  withCredentials: true, //是否允许带cookie这些
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    // "region": region,
    // "uco-user-id": userInfo.userId
  },
  params: {},
});

//请求拦截器
Axios.interceptors.request.use(config => {
  if (config.method === 'get') {
    //消除ie对get请求默认取缓存的影响
    config.params.t = new Date().getTime();
  }
  //有鉴权信息时需带上token
  if (localStorage.getItem('token') && config.url.indexOf('login') <= -1) {
    config.headers.common['X-Train-User-ld'] = localStorage.getItem('userId');
    config.headers.common['X-Train-Auth-Token'] = localStorage.getItem('token');
  }
  return config;
});
//响应拦截器
Axios.interceptors.response.use(
  async res => {
    
    //不需要校验auth
    if (res.headers && res.headers['no-auth'] === 'true') {
      return res;
    }
    if (
      res.headers &&
      (res.headers['content-type'] === 'application/x-msdownload' ||
        res.headers['content-type'] === 'application/force-download')
    ) {
      // 处理文件下载
      let blob = new Blob([res.data]);
      let downloadElement = document.createElement('a');
      let href = window.URL.createObjectURL(blob);
      let fileName = decodeURIComponent(res.headers['content-disposition'].split('=')[1]);
      if ('msSaveOrOpenBlob' in navigator) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        downloadElement.href = href;
        //设置下载文件名字
        downloadElement.download = fileName;
        document.body.appendChild(downloadElement);
        downloadElement.click();
        //释放资源
        document.body.removeChild(downloadElement);
        window.URL.revokeObjectURL(href);
      }
      return res;
    }
    if (res.data && res.data.size) {
      // blob
      let blobPromise = function() {
        return new Promise(resolve => {
          const reader = new FileReader();
          reader.onload = data => {
            let result = data.currentTarget.result;
            resolve(result);
          };
          reader.readAsText(res.data);
        });
      };

      let result = JSON.parse(await blobPromise());
      res.data = result;
    }
    if((!res.config.noTip) && res.data && res.data.code == '9999'){
      Notification({
        title: '失败',
        message: res.data.msg || '操作失败',
        type: 'error',
      });
    }
    //zgy-license-流程ID不存在，刷新界面重新激活
    if(res.data.code == '10019'){
      MessageBox({
        title: '提示',
        showCancelButton:false,
        confirmButtonText:'确定',
        message: '未找到当前流程ID，点击确定将自动刷新界面重新开始激活',
      }).then(()=>{
        window.location.reload();
      });
    }
  
    // if (!localStorage.getItem('token') && !res.config.url.startsWith('/api/uco/kms/nt')) {
    //       localStorage.removeItem('token');
    //       localStorage.removeItem('user');
    //       let CURL = window.location.href;
    //       window.location.href = '/login?url=' + CURL;
    //     }
        return res.data;
  },
  error => {
    if (error.response.status) {
      if (error.response.status === 401 && (error.response.data && error.response.data.auth === true)) {
          MessageBox({
              title: '提示',
              confirmButtonText: '关闭',
              message: '您没有服务权限，请联系主账号前往 IAM 控制台授权',
          });
          return Promise.reject(error);
      }
      else if(error.response.status>=400 && (error.response.config.url.startsWith('/api/networkProduct/network/slb') || error.response.config.url.startsWith('/api/network')||error.response.config.url.startsWith('/api/networks'))){
          
          // if(error.response.status==401){
          //     localStorage.removeItem("token");
          //     localStorage.removeItem("user");
          //     let CURL = window.location.href;
          //     window.location.href = "/login?url=" + CURL;
          // }
        Notification({
            title: '错误',
            message: error.response.data.msg || errorMsgMap[1000] ,
            type: "error"
        });
        return Promise.reject(error);
      } else{
        Notification({
          title: '错误',
          message: error.response.data.msg || errorMsgMap[1000] ,
          type: "error"
        });
      }
  }

    return Promise.reject(error);
  }
);
const install = Vue => {
  Object.defineProperty(Vue.prototype, '$http_ucoKms', { value: Axios });
};
export const util = Axios;
//将axios的实例重新封装成一个plugin，方便 Vue.use(XXX)
export default install;
